<template>
	<div class="container-fluid p-4">
		<!-- <ErrorMessage v-if="config_first_license.get_has_error" /> -->
		<div class="col-md-12">
			<h2 class="fw-bolder fw-bold fs-1 mb-3">
				Teste de microfone
			</h2>
			<p class="fs-5 text-gray-600">
				No grafico abaixo pode verificar o volume do microfone.
			</p>
			<p class="fs-5 text-gray-600">
				Neste teste é possivel se ouvir.
			</p>
			<p class="fs-5 text-gray-600">
				Caso não tenha resposta do gráfico entre em contato com suporte.
			</p>
			<audio id="snapSound" preload="auto"></audio>
			<div
				class="m-auto col-6 progress center-block bg-black bg-opacity-50 rounded">
				<div
					class="progress-bar progress-bar-striped active"
					role="progressbar"
					:style="{
						width: config_first_license.get_average + '%',
					}"></div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-12 col-md-6 my-2">
				<button
					class="btn btn-success gl-2 col-12"
					@click="config_first_license.set_state('test_webcam')">
					<i class="fas fa-check-circle"></i>
					Confirmar
				</button>
			</div>
			<div class="col-12 col-md-6 my-2">
				<a
					class="btn btn-danger col-12"
					href="https://tawk.to/chat/625712c2b0d10b6f3e6d6cfc/1g0i22iep">
					<i class="fas fa-exclamation-triangle"></i>
					Contato suporte
				</a>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { onMounted } from 'vue';
	import { configFirstLicenseStore } from '../../stores/configFirstLicense';

	const config_first_license = configFirstLicenseStore();

	onMounted(() => {
		config_first_license.start_mic();
	});
</script>
